export const initialAbility = [
  {
    action: 'read',
    subject: 'Auth',
  },
  {
    action:'read',
    subject:'Noautorizado'
  }
]

export const _ = undefined
